module.exports = __webpack_public_path__ + "static/img/预算决策.0a240ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/预算决策.jpg
// module id = RrfV
// module chunks = 1